import React, { useState } from "react";
import PaginationComponent from "../../../components/Pagination/Pagination";
import { useNavigate } from "react-router-dom";

const AdminLogTable = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
  };

  const viewAgent = (id) => {
    navigate(`/call-log-admin/agent/${id}`);
  };

  return (
    <>
      <div className="mt-2 bg-white rounded-[8px]">
        {/* tables */}
        <div className="overflow-x-auto relative">
          <table className="w-full text-left">
            <thead className="text-primary text-sm border-b-[#F7F7F7] border-b-2">
              <tr>
                <th scope="col" className="px-4 py-4 font-semibold ">
                  Agent ID
                </th>
                <th scope="col" className="px-4 py-4 font-semibold ">
                  Agent Name
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Call Category
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Date
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Time
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Calls Made
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                onClick={() => viewAgent(1)}
                className="bg-white text-sm cursor-pointer hover:bg-[#EDF7EE]"
              >
                <th
                  scope="row"
                  className="py-4 px-4 font-normal text-[#5C715E] whitespace-nowrap "
                >
                  01
                </th>
                <td className="py-4 px-4 text-[#5C715E]">Celine Avong</td>
                <td className="py-4 px-4 text-[#5C715E]">Temporary Farmers</td>
                <td className="py-4 px-4 text-[#5C715E]">Feb. 22, 2023</td>
                <td className="py-4 px-4 text-[#5C715E]">1:31 pm</td>
                <td className="py-4 px-4">
                  <div className="flex">
                    <div className="success-badge">
                      <p>250/500</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="bg-white text-sm cursor-pointer hover:bg-[#EDF7EE]">
                <th
                  scope="row"
                  className="py-4 px-4 font-normal text-[#5C715E] whitespace-nowrap "
                >
                  01
                </th>
                <td className="py-4 px-4 text-[#5C715E]">Celine Avong</td>
                <td className="py-4 px-4 text-[#5C715E]">Temporary Farmers</td>
                <td className="py-4 px-4 text-[#5C715E]">Feb. 22, 2023</td>
                <td className="py-4 px-4 text-[#5C715E]">1:31 pm</td>
                <td className="py-4 px-4">
                  <div className="flex">
                    <div className="success-badge">
                      <p>250/500</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="bg-white text-sm cursor-pointer hover:bg-[#EDF7EE]">
                <th
                  scope="row"
                  className="py-4 px-4 font-normal text-[#5C715E] whitespace-nowrap "
                >
                  01
                </th>
                <td className="py-4 px-4 text-[#5C715E]">Celine Avong</td>
                <td className="py-4 px-4 text-[#5C715E]">Temporary Farmers</td>
                <td className="py-4 px-4 text-[#5C715E]">Feb. 22, 2023</td>
                <td className="py-4 px-4 text-[#5C715E]">1:31 pm</td>
                <td className="py-4 px-4">
                  <div className="flex">
                    <div className="success-badge">
                      <p>250/500</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-1">
        <PaginationComponent
          page={currentPage}
          onPageChange={(page) => onPageChange({ page })}
          pageSize={10}
          totalItems={200}
        />
      </div>
    </>
  );
};

export default AdminLogTable;
